import ButtonPrimary from "../style-components/ButtonPrimary";

function VariantForm({ variant_type, handleSubmit, variant, handleVariantChange, saveVariant, removeVariant, index }) {
  const isNewVariant = index === -1;
  const variantIndex = isNewVariant ? "new" : index;

  const handleInputChange = (field, value) => {
    handleVariantChange(variantIndex, field, value);
  };

  const renderInput = (field, type = "text", placeholder = "", label = "") => (
    <div className="product-input-container">
      <label>{label}</label>
      <input
        type={type}
        value={variant[field] || ''}
        placeholder={placeholder}
        onChange={(e) => handleInputChange(field, e.target.value)}
      />
    </div>
  );

  const renderDoubleInput = (field, englishField, type = "text", placeholder = "", englishPlaceholder = "", label = "") => (
    <div className="product-input-container">
      <label>{label}</label>
      <input
        type={type}
        value={variant[field] || ''}
        placeholder={placeholder}
        onChange={(e) => handleInputChange(field, e.target.value)}
      />
      <input
        type={type}
        value={variant[englishField] || ''}
        placeholder={englishPlaceholder}
        onChange={(e) => handleInputChange(englishField, e.target.value)}
      />
    </div>
  );

  return (
    <div className="variant-container padding-20-top">
      {!isNewVariant ? 
        <h5 className="light">{index + 1}. {variant_type}: <b>{variant.variant_name}</b></h5> : 
        <h5 className="light">Jauna variācija</h5>
      }
      
      <div className="form-group double">
        {renderDoubleInput("variant_name", "variant_name_english", "text", "Izmēra/krāsas nosaukums (S, M ,L)", "Izmēra/krāsas nosaukums (S, M ,L) angliski", "Nosaukums")}
        {renderInput("price", "number", "Price", "Cena")}
      </div>
      
      <div className="form-group double">
        {renderInput("discount_price", "number", "Discount Price", "Atlaides cena")}
        {renderInput("countInStock", "number", "Count In Stock", "Daudzums noliktavā")}
      </div>
      
      <div className="form-group double">
        {renderInput("sku", "text", "Produkta SKU", "Produkta SKU")}
        {renderInput("weight", "number", "Weight", "Svars (KG)")}
      </div>
      
      <div className="form-group tripple">
        {renderInput("length", "number", "Length", "Garums (cm)")}
        {renderInput("height", "number", "Height", "Augstums (cm)")}
        {renderInput("width", "number", "Width", "Platums (cm)")}
      </div>
      
      <div className="button-container padding-20-top"> 
        {!isNewVariant ? 
          <div className="flex gap-10">
            <ButtonPrimary 
              text="Dzēst izmēru" 
              onClick={(e) => {
                e.preventDefault();
                removeVariant(index);
              }} 
            />
            <ButtonPrimary text="Saglabāt" onClick={handleSubmit} />
          </div>
          :
          <ButtonPrimary 
            text="Saglabāt izmēru" 
            onClick={(e) => {
              e.preventDefault();
              saveVariant();
            }} 
          />
        }
      </div>
    </div>
  );
}

export default VariantForm;